import { useNavigate } from '@ps/web-shared-components';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { select } from '@swf/core/store';
import { c2lHandler } from '@swf/core/utils/c2l';

const AccountC2L: React.FC = () => {
  const history = useHistory();
  const navigate = useNavigate();
  const query = useSelector(select.location.getQuery);

  useEffect(() => {
    if (query.path) {
      c2lHandler(query.path, history, navigate);
    }
  }, [history, navigate, query.path]);

  return null;
};

export default AccountC2L;
